<div class="container">
  <div class="content">
    <div class="left">Tapestry</div>
    <div class="right">
      <div class="title">Welcome back</div>
      <div class="sign-in-options">
        <button
          matButton="elevated"
          class="sign-in"
          color="primary"
          (click)="signIn()">
          Sign in
        </button>
      </div>
    </div>
  </div>
</div>
